module.exports = __webpack_public_path__ + "static/media/fleur-dQf7RZhMOJU-unsplash.a6e3bbfe.jpg";